import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import HomePage from "./pages/HomePage";
import TrackPage from "./pages/TrackPage";
import { PaginaDeErro, PaginaNaoEncontrada } from "./pages/PaginasDeAviso";
import MapaEmbutido from "./pages/MapaEmbutido";

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<PaginaDeErro />}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/track/:trackingCode" element={<TrackPage />} />
          <Route path="/mapa" element={<MapaEmbutido />} />
          <Route path="/mapa/:token" element={<MapaEmbutido />} />
          <Route path="*" element={<PaginaNaoEncontrada />} />
        </Routes>
      </Router>
    </Sentry.ErrorBoundary>
  );
}
